import React from "react";
import styled from "styled-components";

import Teams from "../../api/Teams";

// Shared team-color legend for team-reports bar charts. Renders one
// row of colored dots + "Team {name}" entries so students can map bar
// colors back to teams. Same palette resolution as the chart itself:
// prefers explicit customColors, else Teams.competitiveColors(teams).
const LegendRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 16px;
  justify-content: center;
  margin-top: 8px;
  font-family: 'Mukta Vaani', Lato, sans-serif;
  font-size: 13px;
  color: rgba(0, 27, 59, 0.75);
`;

const LegendItem = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

const LegendDot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${p => p.color};
`;

const TeamLegend = ({ teams, customColors = null }) => {
  if (!teams || teams.length === 0) return null;
  const colors = customColors || Teams.competitiveColors(teams);
  if (!colors || colors.length === 0) return null;
  return (
    <LegendRow>
      {teams.map((team, i) => (
        <LegendItem key={team.id || i}>
          <LegendDot color={colors[i % colors.length]} />
          Team {team.name}
        </LegendItem>
      ))}
    </LegendRow>
  );
};

export default TeamLegend;



// WEBPACK FOOTER //
// ./src/components/analysis/TeamLegend.js